// src/components/notifications/Snackbar.js
import React, { useContext, useEffect, useState } from 'react';
import { NotificationContext } from '../../context/NotificationContext';
import './Snackbar.css';

const Snackbar = () => {
  const { snackbar, clearSnackbar } = useContext(NotificationContext);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (snackbar) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        // Allow time for fade-out animation before clearing the content
        setTimeout(clearSnackbar, 300);
      }, snackbar.duration);

      return () => clearTimeout(timer);
    }
  }, [snackbar, clearSnackbar]);

  if (!snackbar) {
    return null;
  }

  return (
    <div className={`snackbar ${visible ? 'show' : ''}`}>
      <i className="fas fa-check-circle snackbar-icon"></i>
      <span dangerouslySetInnerHTML={{ __html: snackbar.message }} />
    </div>
  );
};

export default Snackbar;
